import React, { useState } from 'react';
import TemplatesList from "./TemplatesList/TemplatesList";
import UploadForm from "./UploadForm/UploadForm";
import PackagedTemplate from "./PackagedTemplate/PackagedTemplate";
import "assets/css/index.css";

const TemplateManager = () => {
      const [activeTab, setActiveTab] = useState("upload");
  return (
    <>
      <div className="app-container">
        <div className="template-manager-card">
          <div className="header">
            <div className="title-section">
              <span><img src="/venza.ico" className="h-30" alt="not found" /></span>
              <h1 className="title">Template Localization Manager</h1>
            </div>
            <div className="tabs">
              <button className={`tab-button ${ activeTab === "templates" ? "active" : ""}`} onClick={() => setActiveTab("templates")}>Templates</button>
              <button className={`tab-button ${ activeTab === "upload" ? "active" : ""}`} onClick={() => setActiveTab("upload")}>Upload New</button>
              <button className={`tab-button ${ activeTab === "packagedTemplate" ? "active" : ""}`} onClick={() => setActiveTab("packagedTemplate")}>Packaged Template</button>
            </div>
          </div>

          <div className="form-container-inner">
              {activeTab === "templates" && <TemplatesList />}
              {activeTab === "upload" && <UploadForm />}
              {activeTab === "packagedTemplate" && <PackagedTemplate />}
          </div>
        </div>
      </div>
    </>
  );
}

export default TemplateManager;